export const getSeriesArray = (seriesObj) => {
    return Object.keys(seriesObj).map((key) => seriesObj[key]);
};

export const minMaxDateFromDataCollection = (seriesObj) => {
    const seriesCollection = getSeriesArray(seriesObj);
    if(!seriesCollection.length){
        return {
            minDate: undefined,
            maxDate: undefined,
        }
    }
    const firstSeriesData = seriesCollection[0].data;

    const minDate = new Date(firstSeriesData[0][0]);
    const maxDate = new Date(firstSeriesData[firstSeriesData.length - 1][0]);

    return {
        minDate,
        maxDate,
    };
};

export const getCurrentLocaleLang = () => {
    const currentLang = document.querySelector("html").getAttribute("lang");
    if (!currentLang) return "enUS";
    if (currentLang == "en") return "enUS";
    return "de";
}; 
